module.exports = __webpack_public_path__ + "static/media/as3cr73.e51863b7.png";